export enum OfflineIconStatus {
    None = 'doc',
    Add = 'doc-add',
    Available = 'doc-available',
    Delete = 'doc-delete',
    Update = 'doc-update'
  }
